import ISO6391 from 'iso-639-1';

import { ComboBoxOption } from '../components/datafields/ComboBoxField';

export const LANGUAGE_OPTIONS: ComboBoxOption[] = ISO6391.getAllNames().map(
  name => ({
    value: name,
    label: name,
  })
);
